import dynamic from "next/dynamic"
import { Culture } from "utils"

const ENV = process.env.ENV

const defaultComponents = {}

const BlockRenderer = ({
  blockType,
  blockData,
  components,
  children,
  culture,
  locale,
  props,
  breadcrumbs,
  searchParams,
}: {
  blockType: string
  blockData: any
  components: any
  children?: any
  props?: any
  locale?: string
  culture?: Culture
  breadcrumbs?: any
  searchParams?: { [key: string]: string | string[] | undefined }
}) => {
  const effectiveComponents = { ...defaultComponents, ...components }

  if (ENV === "development") {
    console.log("blockType ->", blockType)
  }
  if (!effectiveComponents[blockType]) {
    return <div>No Component Found</div> // TODO: remove when production
  }
  // Generate a unique anchor ID based on the blockType and possibly blockData.id if available

  const ComponentToRender = dynamic(effectiveComponents[blockType])

  // Check if the component is a hero banner type and pass breadcrumbs accordingly
  const componentProps = {
    data: blockData,
    locale: locale,
    culture: culture,
    id: props?.id,
    pageUrl: props?.pageUrl,
    ...props,
    ...(blockType
      .toLocaleLowerCase()
      .includes("HeroBanner".toLocaleLowerCase()) && { breadcrumbs }), // Pass breadcrumbs only to hero banner components
  }
  return <ComponentToRender {...componentProps}>{children}</ComponentToRender>
}

export default BlockRenderer
